module.exports = __webpack_public_path__ + "5c07ebcf134e33f49c7739db44077140.fbx";